import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import WaveBand from '../components/WaveBand';
import PhotoGrid from '../components/PhotoGrid';
import { galleryPhotos } from '../data/gallery';
import { site, nextFestival, venue, featurePhoto } from '../data/site';

const stripPhotos = galleryPhotos.filter((p) => p.file !== featurePhoto).slice(0, 12);
const featureImage = galleryPhotos.find((p) => p.file === featurePhoto);

const Home: React.FC = () => (
  <>
    <section className="hero">
      <Container>
        <img
          className="hero__logo mb-4"
          src="/assets/logos/art-on-the-lake-logo-white.png"
          alt="Art on the Lake, Pleasant Hill, Iowa"
        />
        <p className="hero__lede mb-4">{site.tagline}</p>
        <div className="d-flex justify-content-center gap-3 flex-wrap pb-5">
          <Link to="/donate" className="btn btn-primary px-4">Donate</Link>
          <Link to="/gallery" className="btn btn-outline-light px-4">See the Photos</Link>
        </div>
      </Container>
      <WaveBand variant="navy" tall />
    </section>

    <section className="section">
      <Container>
        <div className="notice mx-auto" style={{ maxWidth: '46rem' }}>
          <h2 className="section-title h4 mb-2">{nextFestival.heading}</h2>
          <p className="mb-2">{nextFestival.body}</p>
          <p className="mb-0">
            Want to take part, sponsor, or help out? <Link to="/contact">Get in touch</Link>.
          </p>
        </div>
      </Container>
    </section>

    <section className="section bg-water-soft">
      <Container>
        <div className="text-center">
          <h2 className="section-title">Scenes from the festival</h2>
          <hr className="section-rule" />
          <p className="lede mx-auto mb-4">
            Artists, musicians, food, and families on the shore of {venue.name} in Pleasant Hill.
          </p>
        </div>
        <PhotoGrid photos={stripPhotos} layout="strip" />
        <div className="text-center mt-4">
          <Link to="/gallery" className="btn btn-secondary px-4">
            View the full gallery
          </Link>
        </div>
      </Container>
    </section>

    {featureImage && (
      <section className="section">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <img
                src={`/assets/gallery/full/${featureImage.file}`}
                alt="A community art project on a bridge reading You Are Worth It"
                className="img-fluid"
              />
            </Col>
            <Col lg={5}>
              <h2 className="section-title">Art in the community</h2>
              <hr className="section-rule section-rule--start" />
              <p>
                Beyond the festival, Art on the Lake supports art and culture across the Pleasant
                Hill area: workshops and classes for local artists, low- and no-cost chances to
                show and sell work, and programming open to every age.
              </p>
              <Link to="/about" className="btn btn-secondary px-4">
                About the organization
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    )}
  </>
);

export default Home;
